import React from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "react-redux";
import { useIsAuth } from "@redux";
import { getIsVkSession } from "@extensions";
import Auth from "components/auth/auth";

/**
 * Защита маршрутов: без sessionId показывается диалог Auth.
 * После закрытия без входа — назад в истории или на /home.
 */
const RequireAuth = ({ children }) => {
  const isAuth = useIsAuth();
  const store = useStore();
  const navigate = useNavigate();

  if (getIsVkSession()) {
    return children;
  }

  const handleAuthClose = () => {
    if (store.getState().user?.sessionId) {
      return;
    }
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home", { replace: true });
    }
  };

  if (!isAuth) {
    return <Auth open onClose={handleAuthClose} />;
  }

  return children;
};

export default RequireAuth;
